<div id="login">

  @if (sessionService.loggedOut()) {
    <p-message severity="info" closable i18n>You have been logged out, please login to continue</p-message>
  }

  <p class="small" i18n>Welcome to</p>
  <h2 i18n>Suzuki GB PLC</h2>
  <h3 i18n>Suzuki Gateway Helpdesk number - 0330 058 3955</h3>

  <div class="warning" i18n>Do not attempt to logon unless authorised</div>
  <div [innerHTML]="appService.getLoginMessage()"></div>

  <form onSubmit="return false;">
    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="pi pi-user"></i>
      </p-inputgroup-addon>
      <input
        pInputText
        id="username"
        name="username"
        maxlength="100"
        [(ngModel)]="form!.username"
        (keyup.enter)="login()"
        aria-label="username"
        aria-describedby="username-help"
        placeholder="Username"/>
    </p-inputgroup>
    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="pi pi-key"></i>
      </p-inputgroup-addon>
      <input
        pInputText
        id="password"
        name="password"
        type="password"
        maxlength="100"
        (keyup.enter)="login()"
        [(ngModel)]="form!.password"
        aria-label="Password"
        aria-describedby="password-help"
        placeholder="Password" />
    </p-inputgroup>
    <p-button label="Login" (click)="login()" (keyup.space)="login()" (keyup.enter)="login()"  />
    @if (error) {
      @switch (error) {
        @case('ACCOUNT_LOCKED') {
          <p-message severity="error" closable i18n>Your account is locked or expired. Please contact support for assistance</p-message>
        }
        @case('ACCOUNT_NOT_EXISTS') {
          <p-message severity="error" closable i18n>No account found for this username. Please contact support for assistance</p-message>
        }
        @case('DCS_LOCKED') {
          <p-message severity="error" closable i18n>The DCS is currently disabled! Please try again later</p-message>
        }
        @case ('FORM_INVALID') {
          <p-message severity="error" closable i18n>Please enter your username and password to continue</p-message>
        }
        @case('INTERNAL_SERVER') {
          <p-message severity="error" closable i18n>An unexpected error occurred! Please try again or contact support for assistance</p-message>
        }
        @case('SERVICE_UNAVAILABLE') {
          <p-message severity="error" closable i18n>The system is currently unavailable, please try again later.</p-message>
        }
        @case('UNKNOWN') {
          <p-message severity="error" closable i18n>An unknown error occurred! Please try again or contact support for assistance</p-message>
        }
        @case('NOT_AUTHORISED') {
          <p-message severity="error" closable i18n>Invalid username or password! Please correct and try again</p-message>
        }
        @case('SESSION_EXISTS') {
          <p-message severity="warn" closable i18n>Another session already exists for this user!</p-message>
          <p-button label="Logout other session" (click)="login(true)" (keyup.space)="login(true)" (keyup.enter)="login(true)" i18n />
        }
      }
    }
    <div class="pt-2">
      <div class="panel border">
        <h4 class="mt-0 pt-0 mb-2">Need help?</h4>
        <p class="m-0 pt-0 pb-2"><a class="dark" href="/user-guide" target="_blank" i18n>Download the user guide</a></p>
        <p class="m-0 p-0"><a class="dark" href="https://www.suzukiacademy.co.uk" target="_blank" i18n>View the training video here</a>
      </div>
    </div>
    <div class="p-2 warning small" i18n>
      The systems contained within the Gateway utilise cookies as part of their normal operations.
      By logging into the Gateway you are authorising the use of cookies by Suzuki GB PLC in line with the Privacy Policy.
      If you do not agree to this policy please do not log into the Gateway.
    </div>
</form>
</div>
